document.addEventListener('DOMContentLoaded', function() {
  const uspCarousel = new Swiper('.usp-carousel', {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        centeredSlides: true,
      }
    }
  });
});
